import loadConfiguration3 from './loadConfiguration3'


const app3 = {
    loadConfiguration3,
};

export default app3